const SET_REP_FIRST_NAME = 'SET_REP_FIRST_NAME';
const SET_REP_LAST_NAME = 'SET_REP_LAST_NAME';
const SET_REP_EMAIL = 'SET_REP_EMAIL';
const SET_REP_PHONE = 'SET_REP_PHONE';
const SET_REP_ROLE = 'SET_REP_ROLE';
const SET_SALES_REP = 'SET_SALES_REP';


export {
    SET_REP_FIRST_NAME,
    SET_REP_LAST_NAME,
    SET_REP_EMAIL,
    SET_REP_PHONE,
    SET_REP_ROLE,
    SET_SALES_REP,
};



// WEBPACK FOOTER //
// ./src/containers/common/projectreps/constants.js